import { render } from "./WCItemModifierInstructions.vue?vue&type=template&id=cae85a46"
import script from "./WCItemModifierInstructions.vue?vue&type=script&lang=js"
export * from "./WCItemModifierInstructions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__